import React from 'react'

import Button from '../../components/form/Button'
import TextInput from '../../components/form/TextInput'
import FiltersBox from '../../components/layout/FiltersBox'
import * as utilsLib from '../../../libraries/utils'
import { useI18N } from '../../../libraries/i18n/hook'
import { ContractType } from '../../../api/job-offers/types'
import SearchIcon from '../../../assets/icons/mag-glass.svg?react'
import ContractTypeSelectBox from './ContractTypeSelectBox'
import ShiftTypeSelectBox from './ShiftTypeSelectBox'
import ContractDetailsSelectBox from './ContractDetailsSelectBox'
import CitiesSelectBox from './CitiesSelectBox'
import CareerPathSelectBox from './CareerPathSelectBox'
import { useJobOfferFilter } from '../../../libraries/search/filters'
import ToggleButton from '../../components/form/ToggleButton'

const JobOfferFilters = () => {
  const [showFilters, setShowFilters] = React.useState(false)
  const { filters, setFilters } = useJobOfferFilter()

  const { t } = useI18N()

  const handleTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const text = e.target.value
    setFilters({ text: text.trim() })
  }

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const checked = e.target.checked
    setFilters({ [e.target.name]: checked })
  }

  const debouncedHandleTextChange = utilsLib.debounceFunc(handleTextChange, 300)
  const renderFilters = () => {
    return (
      <div className='my-6 grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-6 gap-4'>
        <TextInput icon={<SearchIcon className='w-5' />} className='w-full' defaultValue={filters.text || ''} onChange={debouncedHandleTextChange} placeholder={t('content.searchByKeyword')} />
        <CareerPathSelectBox onChange={setFilters} values={filters.careerPathIds} label={t('content.sector')} />
        <ContractTypeSelectBox onChange={setFilters} values={filters.contractType} />
        <ContractDetailsSelectBox onChange={setFilters} values={filters.contractDetails} isDisabled={!filters.contractType?.includes(ContractType.INTERNSHIP)} />
        <ShiftTypeSelectBox onChange={setFilters} values={filters.workShiftIds} />
        <CitiesSelectBox onChange={setFilters} values={filters.cityIds} />
        {!filters.hideFilterMyJobOffers && (
          <ToggleButton
            name='myJobOffers'
            id='myJobOffers'
            label={t('jobs.see.applied')}
            onChange={handleCheckboxChange}
            value={filters.myJobOffers?.toString()}
            checked={filters.myJobOffers}
            toggleSize='sm'
          />
        )}
        {!filters.hideFilterIsInternal && (
          <ToggleButton
            name='isInternal'
            id='isInternal'
            label={t('jobs.see.internal')}
            onChange={handleCheckboxChange}
            value={filters.isInternal?.toString()}
            checked={filters.isInternal}
            toggleSize='sm'
          />
        )}

        <div className='flex sm:hidden justify-between mt-4'>
          <Button variant='secondary' outlined onClick={() => setFilters({})}>{t('content.remove.filters')}</Button>
          <Button variant='primary' onClick={() => setShowFilters(false)}>{t('content.see.results')}</Button>
        </div>
      </div>
    )
  }
  return (
    <FiltersBox toggleShowFilters={setShowFilters} showFilters={showFilters}>
      {renderFilters()}
    </FiltersBox>
  )
}

export default JobOfferFilters
